// /components/AdminDashboard.js
import React, { useEffect, useState } from 'react';
import axios from '../services/axios';
import styled from 'styled-components';
import { useUser } from '../context/UserContext';
import { useThemeContext } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  padding: 2rem;
  background: ${({ theme }) => theme.background || '#f9f9f9'};
  font-family: ${({ theme }) => theme.font || 'sans-serif'};
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  background-color: ${({ theme }) => theme.primary || '#007bff'};
  color: ${({ theme }) => theme.buttonText || 'white'};
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover || '#0056b3'};
  }
`;

const ErrorMsg = styled.p`
  color: red;
  font-weight: bold;
  margin: 0.5rem 0 1rem;
`;

function AdminDashboard() {
  const { isPlatformAdmin } = useUser();
  const { theme } = useThemeContext();
  const nav = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [blogError, setBlogError] = useState('');
  const [userError, setUserError] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(true);

  useEffect(() => {
    if (!isPlatformAdmin) return;

    const fetchBlogs = async () => {
      try {
        const res = await axios.get('/api/admin/blogs/');
        setBlogs(Array.isArray(res.data) ? res.data : []);
        setBlogError('');
      } catch (err) {
        setBlogError('Could not load blogs.');
      } finally {
        setLoading(false);
      }
    };

    const fetchUsers = async () => {
      try {
        const res = await axios.get('/api/admin/users/');
        setUsers(Array.isArray(res.data) ? res.data : []);
        setUserError('');
      } catch (err) {
        setUserError('Could not load users.');
      } finally {
        setLoadingUsers(false);
      }
    };

    fetchBlogs();
    fetchUsers();
  }, [isPlatformAdmin]);

  if (!isPlatformAdmin) {
    return (
      <Container theme={theme}>
        <h2>Access Denied</h2>
        <p>You must be a platform administrator to view this page.</p>
      </Container>
    );
  }

  return (
    <Container theme={theme}>
      <h1>Platform Admin</h1>

      <div style={{ margin: '12px 0 20px 0' }}>
        <Button theme={theme} onClick={() => nav('/platform/blogs/create')}>
          Create New Blog
        </Button>
      </div>

      {blogError && <ErrorMsg>{blogError}</ErrorMsg>}
      {userError && <ErrorMsg>{userError}</ErrorMsg>}

      {(loading || loadingUsers) && <p>Loading…</p>}

      {/* Example placeholders */}
      {/* <pre>{JSON.stringify(blogs, null, 2)}</pre> */}
      {/* <pre>{JSON.stringify(users, null, 2)}</pre> */}
    </Container>
  );
}

export default AdminDashboard;
